export const sessionStorageKeys = {
  /* 
    Used to indicate if the user is visiting our pages from an in-app browser (Sketch app, iOS App, ...)
    This is then used to conditionally render some buttons both in our app and the marketing website
   */
  isForInAppPresentation: 'isForInAppPresentation',
  /**
   * Used to check where the user came from. For example "source=pricing" means the user came from the
   * pricing page in the marketing website.
   */
  source: 'source',
} as const

export type SessionKeys = keyof typeof sessionStorageKeys
